exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".spin--3MMoQ {\n  display: inline-block;\n  line-height: 1;\n  animation-timing-function: linear;\n  animation-name: spinAnimation--3Qavb;\n  animation-iteration-count: infinite;\n  animation-duration: 0.75s; }\n  .spin--3MMoQ.slow--3mw3W {\n    animation-duration: 2s; }\n\n.paused--37rbr {\n  animation-play-state: paused; }\n\n@keyframes spinAnimation--3Qavb {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n", ""]);

// exports
exports.locals = {
	"spin": "spin--3MMoQ",
	"spinAnimation": "spinAnimation--3Qavb",
	"slow": "slow--3mw3W",
	"paused": "paused--37rbr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[local]--[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/common/ActivityIndicator/ActivityIndicator.scss
// module id = 405
// module chunks = 4